module.exports = __webpack_public_path__ + "teqbahn-assets/media/23.73e4007a.png";